<script>
import "./vfigma.input.scss";

export default {
  props: {
    input: String,
    placeholder: String,
    disabled: Boolean,
    enter: Function,
    esc: Function,
    optional: Boolean,
    optionalLabel: String,
    focus: Function,
    blur: Function,
    title: String,
    click: Function,
    readonly: Boolean,
    error: Boolean,
    maxlength: String,
    autofocus: Boolean,
    type: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  methods: {
    keyup: function ($event) {
      if ($event.which == 13) {
        $($event.target).blur();
      }
    },
  },
  mounted() {
    if(this.autofocus)
    {
      this.$refs.focusMe.focus();
    }
  }
};
</script>

<template>
  <div class="f-textfield">
    <f-field :optional="optional" :focused="focused" :error="error" :optional-label="optionalLabel">
      <template v-slot:label><slot name="label"></slot></template>
      <template v-slot:content>
        <div class="f-input-container" :class="{ focus: focused, error, disabled }">
          <input
            ref="focusMe"
            class="keepfocus f-input"
            :value="input"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readonly"
            :title="title"
            :maxlength="maxlength"
            @keyup="keyup($event)"
            @focus="
              focused = true;
              $emit('focus', $event);
            "
            @blur="
              focused = false;
              $emit('blur', $event);
            "
            @click="$emit('click', $event)"
            @input="$emit('update:input', $event.target.value)"
            v-on:keyup.enter="$emit('enter')"
            v-on:keyup.esc="$emit('esc')"
            :type="type"
          />
          <div class="f-right" v-if="$slots.action">
            <div class="f-action">
              <slot name="action"></slot>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:helper v-if="$slots.helper"
        ><slot name="helper"></slot
      ></template>
    </f-field>
  </div>
</template>

<style scoped>
.f-textfield >>> .f-field .f-bottom .f-helper {
  margin-top: 1px;
}
</style>